module.exports = __webpack_public_path__ + "img/go_pro.810d84c9.png";